<template>
    <div v-if="ingredient">
        <template v-if="inline">
            <template v-if="!editInline">
                <span v-if="ingredient.id > 0" @click.stop="edit">{{ description }}</span>
            </template>
            <template v-else-if="ingredient.id > 0">
                <b-input v-if="inline === true" type="text" v-model="ingredient.description" @keyup.enter="editInlineSave" @keyup.esc="editInline = false" @click.stop ></b-input>
                <b-form-text>
                    <span v-if="ingredient.raw">{{ ingredient.unit }} {{ ingredient.measure.name }}, {{ ingredient.raw.name }}</span>
                </b-form-text>
                <b-form-text>
                    <span v-if="ingredient.shopping_measure === 'custom'">{{ ingredient.shopping_measure_percent }} {{ ingredient.custom_shopping_description }}</span>
                </b-form-text>
            </template>
        </template>
        <template v-else>
            <span>{{ calculateDescription(ingredient) }}</span>
        </template>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: ['ingredient', 'inline', 'inapp'],
    name: "RecipeIngredient",
    data () {
        return {
            editInline: false
        }
    },
    computed: {
        description() {
            return this.ingredientDescription(this.ingredient, this.$store.state.Settings.multiply)
        }
    },
    methods: {
        edit () {
            if (this.inapp) return
            this.editInline = true
        },
        editInlineSave () {
            this.editInline = false
            let that = this
            axios.post(this.$store.state.Settings.apiUrl + '/ingredient/update-description', {id: this.ingredient.id, description: this.ingredient.description})
                .then(function (response) {
                    that.ingredient.description = response.data.description
                })
        }
    }
}
</script>

<style scoped>

</style>
